// extracted by mini-css-extract-plugin
module.exports = {"container":"PinTab_container__3qX_F","cardContainer":"PinTab_cardContainer__xuCMn","header":"PinTab_header__1bx2-","search-bar":"PinTab_search-bar__UO0bZ"};